import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {
    permissions: {},
    userRole: null,
    isAgent: false,
  }
}

export const permissionSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions: (state, action) => {
      state.value.permissions = action.payload;
    },

    updateUserRole: (state,action) => {
      state.value.userRole = action.payload.userRole;
      state.value.isAgent = action.payload.isAgent;
    },

    clearPermissions: (state) => {
      state.value.permissions = {};
      state.value.userRole = null;
      state.value.isAgent = false;
    },
  },
})

export const { setPermissions, clearPermissions } = permissionSlice.actions

export default permissionSlice.reducer